const BACKEND_DATETIME_REGEX = /^(0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])\/(19\d{2}|20\d{2}) (0\d|1\d|2[0-3]):([0-5]\d):([0-5]\d)$/;

export function formatDateTimeForBackend(datetimeLocalStr) {
  if (!datetimeLocalStr) return '';
  if (BACKEND_DATETIME_REGEX.test(datetimeLocalStr)) return datetimeLocalStr;
  if (!datetimeLocalStr.includes('T')) return '';

  // Crear objeto Date desde lo que el usuario seleccionó
  const date = new Date(datetimeLocalStr);
  if (Number.isNaN(date.getTime())) return '';

  // Obtener segundos actuales del sistema
  const now = new Date();
  date.setSeconds(now.getSeconds());

  // Formatear partes con padding
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  
  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
}

export function toDatetimeLocalFormat(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  const pad = (n) => String(n).padStart(2, '0');
  const yyyy = date.getFullYear();
  const mm = pad(date.getMonth() + 1);
  const dd = pad(date.getDate());
  const hh = pad(date.getHours());
  const mi = pad(date.getMinutes());
  return `${yyyy}-${mm}-${dd}T${hh}:${mi}`;
}
